
export const createDoctorDeepLink = (doctorId: string | number): string => {
  return `ask.dentist://doctor/${doctorId}`;
};

export const createClinicDeepLink = (clinicId: string | number): string => {
  return `ask.dentist://clinic/${clinicId}`;
};
